import styled from '@emotion/styled';
import { Color, Media } from '~/utils/styles/enums';
import { margins, MarginsProps } from '~/utils/styles/mixins/margins';

interface Props extends React.HTMLAttributes<HTMLElement>, MarginsProps {
  padded?: boolean;
  as?: keyof JSX.IntrinsicElements;
}

export const Paper = styled.div<Props>`
  ${({ padded }) => padded && 'padding: 16px'};
  background-color: ${Color.PRIMARY};
  ${margins};

  @media ${Media.LARGE} {
    ${({ padded }) => padded && 'padding: 24px'};
    border-radius: 8px;
  }
`;
